// @flow

import React, { type Node } from 'react';
import { InformationBox } from '../../../../../organisms/information-box';
import { SimpleTipsList, SimpleTipItem} from '../commons/simple-tips';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

export function PagoefectivoInfo(): Node {
  const allFeatures = useAllFeatures();

  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="display_pagoefectivo_instructions">
        <SimpleTipsList>
          <SimpleTipItem>
            <strong>Ojo</strong>: En el cupón hay instrucciones de pago para cada banco.
          </SimpleTipItem>

          <SimpleTipItem>
            Te enviaremos las informaciones para efectuar el pago en tu correo.
          </SimpleTipItem>

          <SimpleTipItem>
            Tendrás hasta 3 dias para realizar tu pago, dependiendo de la hora en que fue generado.
          </SimpleTipItem>
        </SimpleTipsList>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_pagoefectivo_other_methods_tip">
        <InformationBox separatorSize={6}>
          <ul style={{listStylePosition: 'outside'}}>
            <li>Te enviaremos una copia del cupón a tu correo electrónico
              con las instrucciones específicas para cada Banco. </li>
            <li>Recuerda que tienes hasta 3 dias para realizar tu pago.</li>
          </ul>
        </InformationBox>
      </IfFeature>
    </>
  );
}
